const TABS_LIST = {
  DEAL_TABLE: "DEAL_TABLE",
  DOCUMENT: "DOCUMENT",
  QUOTE_TABLE: "QUOTE_TABLE",
};

const QUOTE_STATUS_MAP = [
  { label: "DRAFT", value: "DRAFT" },
  { label: "PENDING APPROVAL", value: "PENDING_APPROVAL" },
  { label: "APPROVED", value: "APPROVED" },
  { label: "REJECTED", value: "REJECTED" },
];

export { QUOTE_STATUS_MAP, TABS_LIST };
